import { yupResolver } from '@hookform/resolvers/yup';
import { useAuth } from '../../Context/useAuth';
import { useForm } from "react-hook-form";
import * as Yup from "yup";

interface Props {}

type RegisterFormsInputs = {
    email: string;
    userName: string;
    password: string;
  };

const validation = Yup.object().shape({
    email: Yup.string()
      .email("Email is invalid")
      .required("Email is required"),
    userName: Yup.string().required("Username is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .required("Password is required"),
  });
const RegisterPage = (props: Props) =>{
    const { registerUser } = useAuth();
    const {
        register,
        handleSubmit,
        formState: { errors },
        } = useForm<RegisterFormsInputs>({
        resolver: yupResolver(validation),
        });

    const handleLogin = (form: RegisterFormsInputs) => {
        registerUser(form.email, form.userName, form.password);
        console.log(form);
    };
  return (
    <section className="bg-#97c0db dark:bg-gray-900">
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div className="w-full bg-slate-500 rounded-lg shadow dark:border md:mb-20 
            sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-oldEnglish font-bold leading-tight tracking-tight 
            text-slate-200 md:text-2xl dark:text-white">
              Sign up to become part of the royal family 👑🎠
            </h1>
            <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit(handleLogin)}>
              <div>
                <label
                  htmlFor="email"
                  className="block mb-2 text-sm font-oldEnglish font-medium text-slate-200 dark:text-white">
                  Email
                </label>
                <input
                  type="text"
                  id="email"
                  className="bg-gray-50 border border-gray-300 text-slate-200 sm:text-sm rounded-lg 
                  focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 
                  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 
                  dark:focus:border-blue-500"placeholder="Email"{...register("email")}/>
                {errors.email ? (
                  <p className="text-white">{errors.email.message}</p>) : ("")}
              </div>
              <div>
                <label
                  htmlFor="username"
                  className="block mb-2 text-sm font-oldEnglish font-medium text-slate-200 dark:text-white">
                  Username
                </label>
                <input
                  type="text"
                  id="username"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg
                   focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700
                    dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500
                     dark:focus:border-blue-500" placeholder="Username"
                  {...register("userName")}/> {errors.userName ? (
                  <p className="text-white">{errors.userName.message}</p> ) : ("")}
              </div>
              <div>
                <label htmlFor="password"
                  className="block mb-2 text-sm font-oldEnglish font-medium text-slate-200 dark:text-white">Password
                </label>
                <input type="password" id="password" placeholder="••••••••"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg
                   focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700
                    dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500
                     dark:focus:border-blue-500" {...register("password")}/>
                {errors.password ? (<p className="text-white">{errors.password.message}</p>) : ("")}
              </div>
       
              <button
                type="submit"
                className="w-full text-slate-800 bg-cyan-300 hover:bg-primary-700 focus:ring-4
                 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5
                  py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
                Sign in
              </button>
            
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default RegisterPage;
